import { createContext } from 'react'

import { AuthContextType } from '../types/interface'

export const AuthContext = createContext<AuthContextType>(null!)
